import React from 'react';
import ServicePage from '../components/services/ServicePage';
import popUpDisplays from '../data/services/pop-up-displays';

const PopUpDisplays: React.FC = () => <ServicePage data={popUpDisplays} />;

export default PopUpDisplays;
